/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadTimData
 */
export interface LeadTimData {
    /**
     * 
     * @type {boolean}
     * @memberof LeadTimData
     */
    execution_available: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeadTimData
     */
    execution_available_reason: LeadTimDataExecutionAvailableReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadTimData
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadTimData
     */
    insurance_type: LeadTimDataInsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LeadTimData
     */
    latest_execution_state: LeadTimDataLatestExecutionStateEnum;
}


/**
 * @export
 */
export const LeadTimDataExecutionAvailableReasonEnum = {
    LeadAnalysisInProgress: 'lead_analysis_in_progress',
    NoPrimaryCommercialInsurance: 'no_primary_commercial_insurance',
    NoContractStored: 'no_contract_stored',
    PayorNotSupported: 'payor_not_supported',
    QuotaExceeded: 'quota_exceeded',
    Null: 'null'
} as const;
export type LeadTimDataExecutionAvailableReasonEnum = typeof LeadTimDataExecutionAvailableReasonEnum[keyof typeof LeadTimDataExecutionAvailableReasonEnum];

/**
 * @export
 */
export const LeadTimDataInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    Null: 'null'
} as const;
export type LeadTimDataInsuranceTypeEnum = typeof LeadTimDataInsuranceTypeEnum[keyof typeof LeadTimDataInsuranceTypeEnum];

/**
 * @export
 */
export const LeadTimDataLatestExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished',
    Null: 'null'
} as const;
export type LeadTimDataLatestExecutionStateEnum = typeof LeadTimDataLatestExecutionStateEnum[keyof typeof LeadTimDataLatestExecutionStateEnum];


/**
 * Check if a given object implements the LeadTimData interface.
 */
export function instanceOfLeadTimData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "execution_available" in value;
    isInstance = isInstance && "execution_available_reason" in value;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "insurance_type" in value;
    isInstance = isInstance && "latest_execution_state" in value;

    return isInstance;
}

export function LeadTimDataFromJSON(json: any): LeadTimData {
    return LeadTimDataFromJSONTyped(json, false);
}

export function LeadTimDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadTimData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'execution_available': json['execution_available'],
        'execution_available_reason': json['execution_available_reason'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'latest_execution_state': json['latest_execution_state'],
    };
}

export function LeadTimDataToJSON(value?: LeadTimData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'execution_available': value.execution_available,
        'execution_available_reason': value.execution_available_reason,
        'payor_id': value.payor_id,
        'insurance_type': value.insurance_type,
        'latest_execution_state': value.latest_execution_state,
    };
}

